import {
	type BroadcastableCommandConstructor,
	type CommandProperties,
} from '@atlassian/rovo-content-bridge-api/command';
import { createBroadcastableCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

/**
 * Properties for the Rovo broadcast actions command.
 *
 * @extends CommandProperties
 */
export interface RovoBroadcastConfirmedActionsCommandProperties extends CommandProperties {
	/**
	 * The unique key identifier for the confirmed action request.
	 */
	key: string;
	/** Content ID targeted by the confirmed action, when available. */
	contentId?: string;
}
/**
 * A command sent by a bridge API client to create a new Rovo confirmed action.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to create a Rovo confirmed action with the specified content.
 */
export const RovoBroadcastConfirmedActionsCommand: BroadcastableCommandConstructor<RovoBroadcastConfirmedActionsCommandProperties> =
	createBroadcastableCommand<RovoBroadcastConfirmedActionsCommandProperties>(
		'rovo-broadcast-confirmed-actions-command',
	);
